import { arrayOf, bool, number, shape, string } from 'prop-types'

/**
 * @typedef {Object} StpParkingPrice
 *
 * @property {bool}     [available]      - whether parking is available
 * @property {number}   [price]          - price of the parking session
 * @property {string}   [currency]       - Currency for the parking session payment
 * @property {string}   [providerName]   - providerName for the parking booking
 * @property {String[]} [accessTypeKeys] - List of access keys for the parking session
 */
export const stpParkingPricePropType = shape({
    available: bool,
    price: number,
    currency: string,
    accessTypeKeys: arrayOf(string),
    providerName: string
})
